import React from 'react';

const Heading = ({ 
    children, 
    level = 1, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    const Tag = `h${level}`;
    
    return (
        <Tag className={className} style={style} {...props}>
            {children}
        </Tag>
    );
};

export default Heading;

